var React = require('react');

function LeftArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.30595 46.0288C-0.0563991 44.2394 -0.0563997 41.7606 1.30595 39.9712L29.5822 2.83115C32.4818 -0.977462 38.5604 1.07314 38.5604 5.85994L38.5604 80.1401C38.5604 84.9269 32.4818 86.9775 29.5822 83.1689L1.30595 46.0288Z"}));
}

LeftArrow.defaultProps = {"width":"39","height":"86","viewBox":"0 0 39 86","fill":"none"};

module.exports = LeftArrow;

LeftArrow.default = LeftArrow;
